/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { AppConfigDefault } from "./AppConfig.default";
import { AppConfigTizen } from "./AppConfig.tizen";
import { AppConfigWebOS } from "./AppConfig.webos";
import { IAppConfig } from "./IAppConfig";
import { resolvePlatformCode } from "./resolvePlatformCode";

let AppConfig: IAppConfig;

switch (resolvePlatformCode()) {
  case "TIZEN":
    AppConfig = new AppConfigTizen();
    break;
  case "WEB_OS":
    AppConfig = new AppConfigWebOS();
    break;
  default:
    AppConfig = new AppConfigDefault();
    break;
}

export { AppConfig };
